import { lazyLoad } from 'utils/loadable';

export const DisableTwoFactorToUser = lazyLoad(
  () => import('./disableTwoFactorToUser.page'),
  (module) => module.DisableTwoFactorToUser
);
